import { useCallback, useEffect, useRef, useState } from 'react'
import { ProjectFormModel, createInitialValue } from '../model'
import { usePageDataIsEdited } from '../../../hooks/usePageDataIsEdited'
import { useEditedFormData } from '../../../containers/SingleSheetV2/hooks/editedFormData'
import { OnChangeProject } from './projectModelModifier'

// ProjectEdit / ProjectInformation で共通のフォーム状態管理。
// formModel の保持・各項目の onChange・編集フラグ追跡のみを担い、
// 取得/保存などのライフサイクルは各 data フックが持つ。
export const useProjectFormState = () => {
  const [formModel, setFormModel] =
    useState<ProjectFormModel>(createInitialValue())
  // submit/delete から最新の formModel を deps に入れずに参照するための ref。
  const formModelRef = useRef(formModel)
  useEffect(() => {
    formModelRef.current = formModel
  }, [formModel])
  const { edited, editedPageData, refreshedPageData } = usePageDataIsEdited()
  const { editedFormData, editFormData, refreshEditedFormData } =
    useEditedFormData()

  const onChangeProject = useCallback<OnChangeProject>(
    (path, value) => {
      setFormModel(prev => ({ ...prev, [path]: value }))
      editedPageData()
      editFormData(path)
    },
    [editedPageData, editFormData]
  )

  return {
    formModel,
    setFormModel,
    formModelRef,
    onChangeProject,
    edited,
    refreshedPageData,
    editedFormData,
    refreshEditedFormData,
  }
}
